"use client";

import React, { useState } from "react";
import SearchInput from "../search/_components/SearchInput";
import { Button } from "@/components/ui/button";
import { useRouter } from "@/i18n/routing";

type Props = {
  buttonText: string;
};

const HomeSearchInput: React.FC<Props> = ({ buttonText }) => {
  const [search, setSearch] = useState("");
  const router = useRouter();

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!search) {
      router.push("/search");
      return;
    }

    router.push(`/search?search=${search}`);
  };
  return (
    <form
      onSubmit={onSubmit}
      className="flex flex-col sm:grid sm:grid-cols-[minmax(0,1fr)_auto] items-stretch sm:items-center gap-2"
    >
      <SearchInput search={search} setSearch={setSearch} />

      <Button type="submit" size="lg">
        <span>{buttonText}</span>
      </Button>
    </form>
  );
};

export default HomeSearchInput;
